import React from "react";

const renderBulletPoints = (info, keyName) => {
    return (
        info &&
        info.map((newInfo, index) => {
            return (
                <li key={index} className="text-left">
                    {keyName ? newInfo[keyName] : newInfo}
                </li>
            );
        })
    );
};

export { renderBulletPoints };
